<template>
	<form-field :label="label" :suffix="suffix" :prefix="prefix">
		<prime-input-number v-bind="$attrs" />
		<template #textprepend>
			<slot name="textprepend"></slot>
		</template>
	</form-field>
</template>

<script setup>
import FormField from '@/components/Form/Field.vue';
import PrimeInputNumber from 'primevue/inputnumber';

defineProps({
	label: String,
	prefix: String,
	suffix: String,
});
</script>
